import {
  EmployeePermission,
  EmployeePermissions,
} from '@appinternal/karyawan-api-services/src/types/employee.type';
import { LocalUser } from '@appinternal/karyawan-api-services/src/types/user.type';

const getLocalUser = (): LocalUser | undefined =>
  JSON.parse(localStorage.getItem('user') || '{}');

const getEmployeeRole = (
  name: keyof EmployeePermissions,
): EmployeePermission => {
  return (
    getLocalUser()?.permissions?.karyawan?.managePermission[name] ?? {
      read: false,
      update: false,
    }
  );
};

export default getEmployeeRole;
